export const PathList = {
  Login: "/",
  Dashboard: "/dashboard",
  Booking: "/booking",
  Booking_Details: "/booking/details",
  Trainer: "/trainer",
  TrainerDetails: "/trainer/details",
  Notification: "/notification",
  PaymentHistory: "/payment/history",
  Support: "/support",
  Chat: "/chat",
  UserManagement: "/user",
  UserDetails: "/user/details",
  UserFitnessDashboard: "/user/fitness",
  FAQs: "/faqs",
  AppIssue: "/appissue",
  Setting: "/setting",
  PlanDetails:"/plan/details",
  PromoCode:"/promo_code",
  PromoCodeCreate:"/promo_code/create",
  EditPromoCode:"/promo_code/edit",
  request:"/requests",
  Plans:"/plans",
  AddPlan:"/plans/add",
  EditPlan:"/plans/edit",

  Badge:"/badges",
  AddBadge:"/badges/add",
  EditBadge:"/badges/edit",

  challenge:"/challenges",
  AddChallenge:"/challenges/add",
  EditChallenge:"/challenges/edit",
  ConvertChallenge:"/challenges/convert",

  StripeSuccess:"/stripe/success",
  StripeError:"/stripe/error",

  ActivityLogs:"/activity_logs",
  WhoopRequests:"/whoop_requests",
  ContractAgreement:"/contract_agreement",
};
